import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  skillError: null,
  skillLoading: false,
  dataAction: null,
  skillAction: null,
  transferAction: null,
  transferMsg: null,
  transferableAgents: {},
  transferableCampaign: {},
  transferableSkills: {},
  transferableExtension: {},
};

// 1. get Transferable Agents
const getTransferableAgentsFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const getTransferableAgentsStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const getTransferableAgentsSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableAgents: action.transferableAgents,
    dataAction: 'Agent',
    transferAction: null,
  });
};

// 2. get Transferable Campaign
const getTransferableCampaignFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const getTransferableCampaignStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const getTransferableCampaignSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableCampaign: action.transferableCampaign,
    dataAction: 'Campaign',
    transferAction: null,
  });
};

// 3. get Transferable Skill
const getTransferableSkillFail = (state, action) => {
  return updateObject(state, {skillError: action.error, skillLoading: false});
};

const getTransferableSkillStart = (state, action) => {
  return updateObject(state, {skillError: null, skillLoading: true});
};

const getTransferableSkillSuccess = (state, action) => {
  return updateObject(state, {
    skillError: null,
    skillLoading: false,
    transferableSkills: action.transferableSkills,
    dataAction: 'Campaign',
    skillAction: 'Skill',
    transferAction: null,
  });
};

// 4. get Transferable Extension
const getTransferableExtensionFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const getTransferableExtensionStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const getTransferableExtensionSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableExtension: action.transferableExtension,
    dataAction: 'Extension',
    transferAction: null,
  });
};

// 5. Transfer Agent
const transferAgentFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const transferAgentStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const transferAgentSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableAgents: {},
    dataAction: null,
    transferAction: 'Agent ' + action.transferMsg,
  });
};

// 6. Transfer Campaign
const transferCampaignFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const transferCampaignStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const transferCampaignSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableCampaign: {},
    transferableSkills: {},
    dataAction: null,
    skillAction: null,
    transferAction: 'Campaign ' + action.transferMsg,
  });
};

// 7. Transfer Extension
const transferExtensionFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const transferExtensionStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const transferExtensionSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    transferableExtension: {},
    dataAction: null,
    transferAction: 'Extension ' + action.transferMsg,
  });
};

export const unsetTransferSuccess = (state, action) => {
  return {
    error: null,
    loading: false,
    dataAction: null,
    transferAction: null,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TRANSFERABLE_AGENTS_START:
      return getTransferableAgentsStart(state, action);
    case actionTypes.GET_TRANSFERABLE_AGENTS_SUCCESS:
      return getTransferableAgentsSuccess(state, action);
    case actionTypes.GET_TRANSFERABLE_AGENTS_FAIL:
      return getTransferableAgentsFail(state, action);

    case actionTypes.GET_TRANSFERABLE_CAMPAIGN_START:
      return getTransferableCampaignStart(state, action);
    case actionTypes.GET_TRANSFERABLE_CAMPAIGN_SUCCESS:
      return getTransferableCampaignSuccess(state, action);
    case actionTypes.GET_TRANSFERABLE_CAMPAIGN_FAIL:
      return getTransferableCampaignFail(state, action);

    case actionTypes.GET_TRANSFERABLE_SKILL_START:
      return getTransferableSkillStart(state, action);
    case actionTypes.GET_TRANSFERABLE_SKILL_SUCCESS:
      return getTransferableSkillSuccess(state, action);
    case actionTypes.GET_TRANSFERABLE_SKILL_FAIL:
      return getTransferableSkillFail(state, action);

    case actionTypes.GET_TRANSFERABLE_EXTENSION_START:
      return getTransferableExtensionStart(state, action);
    case actionTypes.GET_TRANSFERABLE_EXTENSION_SUCCESS:
      return getTransferableExtensionSuccess(state, action);
    case actionTypes.GET_TRANSFERABLE_EXTENSION_FAIL:
      return getTransferableExtensionFail(state, action);

    case actionTypes.TRANSFER_AGENT_START:
      return transferAgentStart(state, action);
    case actionTypes.TRANSFER_AGENT_SUCCESS:
      return transferAgentSuccess(state, action);
    case actionTypes.TRANSFER_AGENT_FAIL:
      return transferAgentFail(state, action);

    case actionTypes.TRANSFER_CAMPAIGN_START:
      return transferCampaignStart(state, action);
    case actionTypes.TRANSFER_CAMPAIGN_SUCCESS:
      return transferCampaignSuccess(state, action);
    case actionTypes.TRANSFER_CAMPAIGN_FAIL:
      return transferCampaignFail(state, action);

    case actionTypes.TRANSFER_EXTENSION_START:
      return transferExtensionStart(state, action);
    case actionTypes.TRANSFER_EXTENSION_SUCCESS:
      return transferExtensionSuccess(state, action);
    case actionTypes.TRANSFER_EXTENSION_FAIL:
      return transferExtensionFail(state, action);

    case actionTypes.TRANSFER_UNSET_SUCCESS:
      return unsetTransferSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
